import React from "react";
import clsx from "clsx";

// Material
import { makeStyles } from "@material-ui/core/styles";
import ButtonBase from "@material-ui/core/ButtonBase";
import Paper from "@material-ui/core/Paper";
import Zoom from "@material-ui/core/Zoom";

// Components
import Text, { types } from "../Text/Text";

const useStyles = makeStyles(theme => ({
  button: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "stretch",
    marginBottom: theme.spacing(1.2),
    backgroundColor: "rgba(255, 255, 255, 0.9)",
    backdropFilter: "blur(4px)",
    boxShadow: "0px 1px 3px #0000000A",
    transition: "all .2s ease-in-out",
    width: 400,
    position: "relative",
    borderRadius: 4,
    overflow: "hidden",
    height: "80px",
    [theme.breakpoints.down("md")]: {
      width: 260,
      marginBottom: theme.spacing(1)
    }
  },
  buttonSelected: {
    boxShadow: "0px 1px 63px #0000001C",
    transform: "translateX(60px)",
    backgroundColor: "rgba(229, 248, 255, 0.9)"
  },
  buttonNotSelected: {
    "&:hover": {
      // padding: theme.spacing(2),
      transform: "translateX(30px)",
      boxShadow: "0px 1px 30px #0000001C"
    }
  },
  iconWrapper: {
    backgroundColor: ({ color }) => color,
    width: "78px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },
  title: {
    padding: theme.spacing(2.5),
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.down("md")]: {
      padding: theme.spacing(1.5)
    }
  },
  contentPanel: {
    marginLeft: "50%",
    outline: "1px solid red",
    width: "50%"
  },
  zoomDelay: {
    transitionDelay: props => `${props.delay}ms`
  }
}));

const HomeSubsectionNavButton = ({
  icon,
  color,
  isSelected,
  onClick,
  title,
  isInViewport,
  delay,
  id
}) => {
  const classes = useStyles({ color, delay });
  return (
    <Zoom direction="right" in={isInViewport} timeout={500}>
      <div className={classes.zoomDelay}>
        <ButtonBase
          className={clsx(classes.button, {
            [classes.buttonNotSelected]: !isSelected,
            [classes.buttonSelected]: isSelected
          })}
          component={Paper}
          elevation={0}
          onClick={onClick}
        >
          <div className={classes.iconWrapper}>
            <img src={icon} alt={id} />
          </div>
          <Text type={types.buttonLinkTitle} className={classes.title}>
            {title}
          </Text>
        </ButtonBase>
      </div>
    </Zoom>
  );
};

const areEqual = (prev, next) =>
  prev.isInViewport === next.isInViewport &&
  prev.isSelected === next.isSelected;

export default React.memo(HomeSubsectionNavButton, areEqual);
